import type { ReactElement } from 'react';

import { useDentistsContext } from '../..';
import DocList from './DocList';
import Map from './Map';

export default function DentistsFound(): ReactElement {
  const { docList, loading } = useDentistsContext();
  const mapDocList = loading ? [] : docList;

  return (
    <div className="grid w-full gap-5 min-[1180px]:grid-cols-[minmax(340px,420px)_minmax(0,1fr)] min-[1180px]:items-stretch">
      <DocList
        docList={docList}
        loading={loading}
        className="min-[1180px]:h-[620px]"
      />
      <Map
        docList={mapDocList}
        loading={loading}
        showEmptyState={!loading}
        className="h-[440px] w-full overflow-hidden rounded-lg min-[1180px]:h-[620px]"
      />
    </div>
  );
}
